import { truncateString } from '../../shared/functions/Functions';

export const getTruncatedData = (name: string, limit = 25) => ({
    truncatedName: truncateString(name, limit),
    isTruncated: name.length > limit,
});
